module.exports = __webpack_public_path__ + "img/circle-check-filled.0c8a546d.svg";